export class MathUtils {
    static average(values: Array<number>): number {
        let totalSum: number = values.reduce((sum, value) => { 
            return sum + value;
        }, 0);
  
        const avg: number = totalSum / values.length;
        return avg;
    }

    static avg(values: Array<number>): number {
        return MathUtils.average(values);
    }

    static standardDeviation(values: Array<number>): number {
        const avg: number = this.average(values);
  
        const squareDiffs: Array<number> = values.map((value: number) => {
          const diff: number = value - avg;
          const sqrDiff: number = diff * diff;
          return sqrDiff;
        });
        
        const avgSquareDiff: number = this.average(squareDiffs);
      
        const stdDev: number = Math.sqrt(avgSquareDiff);
        return stdDev;
    }

    static stdDev(values: Array<number>): number {
        return MathUtils.standardDeviation(values);
    }

    static cmToFtIn(cm: number): { ft: number; inches: number } {
        const totalInches = cm / 2.54;
        const ft = Math.floor(totalInches / 12);
        const inches = MathUtils.round(totalInches % 12, 1);
        return { ft, inches };
    }

    static ftInToCm(ft: number, inches: number): number {
        return MathUtils.round((ft * 12 + inches) * 2.54, 1);
    }

    static lbsToKg(lbs: number): number {
        return MathUtils.round(lbs / 2.2046, 1);
    }

    static kgToLbs(kg: number): number {
        return MathUtils.round(kg * 2.2046, 1);
    }

    // BMI from weight in lbs and height in cm
    static bmi(weightLbs: number, heightCm: number): number {
        const heightM = heightCm / 100;
        return MathUtils.round(MathUtils.lbsToKg(weightLbs) / (heightM * heightM), 1);
    }

    static round(value: number, precision: number) {
        const shift =  (numericValue: number, precisionNumber: number, reverseShift: boolean) => {
          if (reverseShift) {
            precisionNumber = -precisionNumber;
          }  
          const numArray = ('' + numericValue).split('e');
          return +(numArray[0] + 'e' + (numArray[1] ? (+numArray[1] + precisionNumber) : precisionNumber));
        };
        return shift(Math.round(shift(value, precision, false)), precision, true);
    }  

}